<template>
  <div class="users">
    <mainmenu selected="users"></mainmenu>

    <div class="container-fluid">
      <h1>{{ $t("users.page_title") }}</h1>
      <p>
        <el-button @click='add_item()'>{{ $t("add_item") }}</el-button>
      </p>

      <el-table :data="Results" style="width: 100%" v-loading="tableLoadingVisible">
        <el-table-column prop="Name" :label="$t('users.name')" width="200"></el-table-column>
        
        <el-table-column prop="UserType" :label="$t('users.user_group')" width="200"></el-table-column>

        <el-table-column prop="Email" :label="$t('users.email')"  width="300"></el-table-column>
        <el-table-column prop="FactoryCountry" :label="$t('users.factory_country')"></el-table-column>
        <el-table-column prop="FactoryShortCode" :label="$t('users.factory_code')" ></el-table-column>

        <el-table-column fixed="right" :label="$t('operations')" width="300">
          <template slot-scope="scope">
            <el-button @click="change_password(scope.row)"   type="text" size="small">{{ $t("users.change_password") }}</el-button>

            <el-button @click="edit_item(scope.row)"   type="text" size="small">{{ $t("edit") }}</el-button>
            <el-button @click="delete_item(scope.row)" type="text" size="small">{{ $t("delete") }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "pager">
      </el-pagination>
    </div>
    <user-dialog ref="item_dialog" @save='refresh_info' />
    <change-password-dialog ref="change_pass_dialog" />
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";
import UserDialog from "./../views/dialogs/UserDialog";
import ChangePasswordDialog from "./../views/dialogs/ChangePasswordDialog";

export default {
  name: "users",
  components: {
    "mainmenu": MainMenu,
    "user-dialog": UserDialog,
    "change-password-dialog": ChangePasswordDialog
  },
  data () {
    return { 
      tableLoadingVisible: false,
      Results: [],
      Filters: {},
      PaginationInfo: { Page: 1, PerPage: 10, RowCount: 0, PageSizes: [10, 25, 50, 100] }
    }
  },
  methods: {
     refresh_info: function() {
       this.tableLoadingVisible = true;
       this.$http
          .post('users/refresh_info',  { Filters: this.Filters, PaginationInfo: this.PaginationInfo } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.Results = response.body.Results;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          });
    },
    change_password: function( user ){
      this.$refs.change_pass_dialog.show_me( user.Id );
    },
    add_item: function(){
      this.$refs.item_dialog.show_me();
    },
    edit_item: function(item){
      this.$refs.item_dialog.show_me(item);
    },
    delete_item: function(item){
       this.$confirm( this.$t("confirm_delete"), this.$t("warning_title"), { 
         confirmButtonText: this.$t("confirm"), 
         cancelButtonText: this.$t("cancel"), 
         type: 'warning'
        }).then(() => {
          this.tableLoadingVisible = true;
          this.$http
              .post('users/delete_item',  { object: item } )
              .then(function (response) {
                this.tableLoadingVisible = false;
                if( settings.verify_response(response, this.$rights)) {
                  this.refresh_info();
                } else {
                  this.$router.push("/");
                }
              });
        }).catch(()=>{ });
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>

</style>